import { useEffect, useRef, useState } from "react";
import { Alert, Col } from "react-bootstrap";
import { ReactComponent as CheckBoxUnselectedHover } from '../../Assets/img/CheckBoxUnselectedHover.svg';
import { ReactComponent as CheckBoxPartial } from '../../Assets/img/CheckBoxPartial.svg';
import { ReactComponent as CheckBoxPartialHover } from '../../Assets/img/CheckBoxPartialHover.svg';
import { ReactComponent as CheckBoxAllSelected } from '../../Assets/img/CheckBoxAllSelected.svg';
import { ReactComponent as CheckBoxUnselected } from '../../Assets/img/CheckBoxUnselected.svg';
import { ReactComponent as CheckBoxSelected } from '../../Assets/img/CheckBoxSelected.svg';
import { ReactComponent as CheckBoxSelectedHover } from '../../Assets/img/CheckBoxSelectedHover.svg';
import { ReactComponent as CheckBoxAllSelectedHover } from '../../Assets/img/CheckBoxAllSelectedHover.svg';
import { ReactComponent as DescendingIcon } from '../../Assets/img/DescendingIcon.svg';
import { ReactComponent as AscendingIcon } from '../../Assets/img/AscendingIcon.svg';
import { ReactComponent as DescendingHoverIcon } from '../../Assets/img/DescendingHoverIcon.svg';
import { ReactComponent as AscendingHoverIcon } from '../../Assets/img/AscendingHoverIcon.svg';
import { ReactComponent as Edit } from '../../Assets/img/EditPen.svg';
import { ReactComponent as EditPenHover } from '../../Assets/img/EditPenHover.svg';
import { ReactComponent as ForceRotate } from '../../Assets/img/Reset.svg';
import { ReactComponent as Show } from '../../Assets/img/Show.svg';
import { ReactComponent as Hide } from '../../Assets/img/Hide.svg';
import { ReactComponent as Filterclearbutton } from '../../Assets/img/Filter-input-clearbutton.svg';
import { ReactComponent as Filterclearbuttonhover } from '../../Assets/img/Filter-input-clearbutton-hover.svg';
import { ModalFooter } from 'react-bootstrap';
import moment from "moment";
import ReactPopup from 'reactjs-popup';
import DatePicker from "react-datepicker";
import { CSVLink } from "react-csv";
import { createColumnHelper, flexRender, getCoreRowModel, useReactTable, } from '@tanstack/react-table'

import DeviceService from "../../Services/DeviceService";
import LoadingIndicator from "../CommonComponent/LoadingIndicator";
import NoMatch from "../CommonComponent/NoMatch";
import AddDevice from "../DeviceComponent/AddDevice";
import BulkEditDevices from "../DeviceComponent/BulkEditDevices";
import Footer from "../FooterComponent/Footer";
import PageTable from "../PageComponent/PageTable";
import PageTop from "../PageComponent/PageTop";
import MessagePopup from "../PopupComponent/MessagePopup";
import WarningMessagePopup from "../PopupComponent/WarningMessagePopup";
import EditDevice from "./EditDevice";
import UploadDevice from "./UploadDevice";
import Navigation from "../NavigationComponent/Navigation";
import TopNavigation from "../NavigationComponent/TopNavigation";
import TextFilterBox from "../PopupComponent/TextFilterBox";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "../../Assets/css/bootstrap.css";
import ReactCalendarPopup from "../PopupComponent/ReactCalendarPopup";

const columnHelper = createColumnHelper();
const columns = [columnHelper.accessor('Device Name', {
    cell: info => <span style={{ width: info.column.getSize() }}>{info.getValue()}</span>,
    header: info => <span style={{ width: info.column.getSize() }}>Device Name</span>,
    id: "DeviceName",
    meta: {
        sortFieldName: "name",
        type: "string"
    }
}), columnHelper.accessor('Serial Number', {
    cell: info => <span style={{ width: info.column.getSize() }}>{info.getValue()}</span>,
    header: info => <span style={{ width: info.column.getSize() }}>Serial Number</span>,
    id: "SerialNum",
    meta: {
        sortFieldName: "deviceserialnum",
        type: "string"
    }
}), columnHelper.accessor('Device Model', {
    cell: info => <span style={{ width: info.column.getSize() }}>{info.getValue()}</span>,
    header: info => <span style={{ width: info.column.getSize() }}>Device Model</span>,
    id: "DeviceModel",
    meta: {
        sortFieldName: "model",
        type: "string"
    }
}), columnHelper.accessor('Issued On', {
    cell: info => <span style={{ width: info.column.getSize() }}>{info.getValue() ? moment(info.getValue()).format('DD-MMM-YYYY') : null}</span>,
    header: info => <span style={{ width: info.column.getSize() }}>Issued On</span>,
    id: "IssueDate",
    meta: {
        sortFieldName: "certgenerationdate",
        type: "date"
    }
}), columnHelper.accessor('Expired On', {
    cell: info => <span style={{ width: info.column.getSize() }}>{info.getValue() ? moment(info.getValue()).format('DD-MMM-YYYY') : null}</span>,
    header: info => <span style={{ width: info.column.getSize() }}>Expired On</span>,
    id: "ExpiredDate",
    meta: {
        sortFieldName: "certexpirydate",
        type: "date"
    }
}), columnHelper.accessor('Is Active', {
    cell: info => <span style={{ width: info.column.getSize() }}>{info.getValue()}</span>,
    header: info => <span style={{ width: info.column.getSize() }}>Is Active</span>,
    id: "IsActive",
    meta: {
        sortFieldName: "isactive",
        type: "bool"
    }
})];

/**
 * Renders device page with all the registered devices and device functions
 * @component
 */
function Device() {

    //#region States

    const [state, setState] = useState({
        status: "LOADING",
        deviceDetails: null,
        error: null,
        serialNum: "",
        deviceId: "",
        perPage: 20,
        currentPage: 0,
        pageCount: 0,
        totalDataCount: 0,
        sortField: null,
        sortType: null,
        selectedItems: [],
        showFilter: false,
        allColumnFilter: null,
        deviceNameFilter: null,
        deviceSerialNumberFilter: null,
        deviceModelFilter: null,
        issueDateFilter: null,
        expDateFilter: null,
        isActiveFilter: null,
        searchDeviceName: "",
        searchSerialNumber: "",
        searchDeviceModel: "",
        searchIssueDate: "",
        searchExpDate: "",
        searchIsActive: "",
        isTableLoading: false,
        issueFromDate: 'DD/MM/YYYY',
        issueToDate: 'DD/MM/YYYY',
        expFromDate: 'DD/MM/YYYY',
        expToDate: 'DD/MM/YYYY',
        model: null,
        success: null,
        message: null,
        hiddenColumns: [],
        allDevices: [],
        selectedItemsForPopup: [],
        triggerCSVDownload: false
    });

    //#endregion

    //#region Refs

    const searchValue = useRef();
    const issueDatePopupRef = useRef();
    const expDatePopupRef = useRef();
    const csvRef = useRef();

    const [data, setData] = useState([]);

    const table = useReactTable({
        data,
        columns,
        columnResizeMode: "onChange",
        getCoreRowModel: getCoreRowModel(),
    });
    //#endregion

    //#region CSV headers

    const csvHeader = [
        { label: "Device Id", key: "DeviceId" },
        { label: "Device Name", key: "DeviceName" },
        { label: "Serial Num", key: "DeviceSerialNum" },
        { label: "Status", key: "Status" },
        { label: "Make", key: "Make" },
        { label: "Model", key: "Model" },
        { label: "Issue Date", key: "CertGenerationDate" },
        { label: "Expiry Date", key: "CertExpiryDate" }
    ];

    //#endregion

    //#region useEffect hook

    /**
    * Calls loadDeviceDetails() method to get device details
    * Runs on state change of state.currentPage, state.sortField, state.sortType, state.perPage, state.allColumnFilter, state.deviceNameFilter,state.deviceSerialNumberFilter, state.deviceModelFilter, state.issueDateFilter, state.expDateFilter, state.isActiveFilter
    */
    useEffect(() => {
        async function fetchData() {
            await loadDeviceDetails();
        }
        fetchData();
    }, [state.currentPage, state.sortField, state.sortType, state.perPage, state.allColumnFilter, state.deviceNameFilter,
    state.deviceSerialNumberFilter, state.deviceModelFilter, state.issueDateFilter, state.expDateFilter, state.isActiveFilter]);

    /**
   * Calls loadDeviceDetails() method to get device details on successfull execution of device service methods
   * Runs only on state change of state.success
   */
    useEffect(() => {
        async function fetchData() {
            await loadDeviceDetails();
        }
        if (state.success == true) {
            fetchData();
        }
    }, [state.success]);

    useEffect(() => {
        if (state.triggerCSVDownload) {
            csvRef.current.link.click();
            setState((currentState) => ({
                ...currentState,
                triggerCSVDownload: false
            }));
        }
    }, [state.triggerCSVDownload])

    //#endregion

    //#region Device functions

    /**
    * Calls device service to fetch devices according to device filters
    */
    const loadDeviceDetails = async () => {
        setState((currentState) => ({
            ...currentState,
            isTableLoading: true,
        }));

        try {
            var request = {
                Filters: [state.allColumnFilter, state.deviceNameFilter, state.deviceSerialNumberFilter, state.deviceModelFilter,
                state.issueDateFilter, state.expDateFilter, state.isActiveFilter].filter(f => f != null),
                Sort: (state.sortField == null || state.sortType == null) ? [] : [{
                    SortField: state.sortField,
                    sortType: state.sortType
                }],
                Pagination: {
                    PageStart: state.currentPage,
                    PageFetch: state.perPage
                }
            }
            const response = await DeviceService.GetDevicesPerPage(request);

            var responseD = [];
            response.Data.forEach((device) => {
                responseD.push({
                    "Device Name": device.DeviceName,
                    "Serial Number": device.DeviceSerialNum,
                    "Device Model": device.Model,
                    "Issued On": device.CertGenerationDate,
                    "Expired On": device.CertExpiryDate,
                    "Is Active": device.Status
                })
            })
            setData(responseD);

            setState((currentState) => ({
                ...currentState,
                status: "LOADED",
                isTableLoading: false,
                deviceDetails: response.Data,
                pageCount: Math.ceil(
                    response.TotalRecord / state.perPage
                ),
                totalDataCount: response.TotalRecord
            }));
        } catch (error) {
            setState((currentState) => ({
                ...currentState,
                status: "ERROR",
                error: error,
            }));
        }
    };

    /**
    * Calls device service to fetch all registered devices
    */
    const getAllDevices = async () => {
        DeviceService.GetDevices().then((devices) => {
            setState((currentState) => ({
                ...currentState,
                allDevices: devices,
                triggerCSVDownload: true
            }));
        }).catch((error) => {
            setState((currentState) => ({
                ...currentState,
                status: "ERROR",
                error: error,
            }));
        });
    }

    /**
    * Move to next page
    */
    const nextPageHandler = () => {
        if (state.currentPage + 2 > state.pageCount) {
            return;
        }
        setState((currentState) => ({
            ...currentState,
            currentPage: currentState.currentPage + 1,
            selectedItems: []
        }));
    }

    /**
    * Move to previous page
    */
    const previousPageHandler = () => {
        if (state.currentPage - 1 < 0) {
            return;
        }
        setState((currentState) => ({
            ...currentState,
            currentPage: currentState.currentPage - 1,
            selectedItems: []
        }));
    }

    /**
    * Move to first page
    */
    const firstPageHandler = () => {
        if (state.currentPage == 0) {
            return;
        }
        setState((currentState) => ({
            ...currentState,
            currentPage: 0,
            selectedItems: []
        }));
    }

    /**
    * Move to last page
    */
    const lastPageHandler = () => {
        if (state.currentPage == state.pageCount - 1) {
            return;
        }
        setState((currentState) => ({
            ...currentState,
            currentPage: currentState.pageCount - 1,
            selectedItems: []
        }));
    }

    /**
    * Sort the given field  ("asc" to "desc", "desc" to "asc", null to "asc") 
    * @param   {String} field  Coloumn name that user wants to change 
    */
    const sort = (field) => {
        var type = state.sortType;
        var fieldValue = state.sortField;
        if (type == null) {
            type = "asc";
        }
        else if (type == "asc") {
            if (fieldValue == field) {
                type = "desc";
            }
            else {
                type = "asc";
            }
        }
        else {
            if (fieldValue == field) {
                type = null;
            }
            else {
                type = "asc";
            }
        }

        setState((currentState) => ({
            ...currentState,
            sortField: field,
            sortType: type,
            selectedItems: []
        }));
    }

    /**
    * Push the device into the list of selected devices 
    * @param   {Object} device  Object that contains DeviceId,DeviceName,DeviceSerialNum,Status,Make,Model,CertGenerationDate,CertExpiryDate
    */
    const selectItem = (device) => {
        var selected = state.selectedItems;
        selected.push(device);
        setState((currentState) => ({
            ...currentState,
            selectedItems: selected
        }));
    }

    /**
    * Remove the device from the list of selected devices 
    * @param   {Object} device  Object that contains DeviceId,DeviceName,DeviceSerialNum,Status,Make,Model,CertGenerationDate,CertExpiryDate
    */
    const unSelectItem = (device) => {
        var selected = state.selectedItems.filter(sel => sel != device);
        setState((currentState) => ({
            ...currentState,
            selectedItems: selected
        }));
    }

    /**
    * Push all the devices into the list of selected devices 
    */
    const selectAllItems = () => {
        var selected = [];
        state.deviceDetails.forEach(device => {
            selected.push(device);
        });
        setState((currentState) => ({
            ...currentState,
            selectedItems: selected
        }));
    }

    /**
    * Remove all the devices from the list of selected devices 
    */
    const unSelectAllItems = () => {
        setState((currentState) => ({
            ...currentState,
            selectedItems: []
        }));
    }

    /**
    * Changes the number of device per page according to user input
    * @param    {Event} event  User action (on changing value)
    */
    const changePerPage = (event) => {
        setState((currentState) => ({
            ...currentState,
            perPage: event.target.value,
            currentPage: 0,
            selectedItems: []
        }));
    }

    /**
    * Search device 
    */
    const searchAllColumn = () => {
        var filter;
        if (searchValue.current.value == "") {
            filter = null;
        }
        else {
            filter = {
                Type: "contains",
                Value: searchValue.current.value
            }
        }
        setState((currentState) => ({
            ...currentState,
            allColumnFilter: filter
        }));
    }

    /**
    * Search device by device name
    * @param    {Event} event  User action (on changing value)
    */
    const searchByDeviceName = (event) => {
        setState((currentState) => ({
            ...currentState,
            searchDeviceName: event.target.value
        }));

        var filter;
        if (event.target.value == "") {
            filter = null;
        }
        else {
            filter = {
                ColumnName: "name",
                Type: "contains",
                Value: event.target.value
            };
        }
        setState((currentState) => ({
            ...currentState,
            deviceNameFilter: filter
        }));
    }

    /**
   * Search device by device serial number
   * @param    {Event} event  User action (on changing value)
   */
    const searchBySerialNumber = (event) => {
        setState((currentState) => ({
            ...currentState,
            searchSerialNumber: event.target.value
        }));

        var filter;
        if (event.target.value == "") {
            filter = null;
        }
        else {
            filter = {
                ColumnName: "deviceserialnum",
                Type: "contains",
                Value: event.target.value
            }
        }
        setState((currentState) => ({
            ...currentState,
            deviceSerialNumberFilter: filter
        }));
    }

    /**
   * Search device by device model
   * @param    {Event} event  User action (on changing value)
   */
    const searchByDeviceModel = (event) => {
        setState((currentState) => ({
            ...currentState,
            searchDeviceModel: event.target.value
        }));

        var filter;
        if (event.target.value == "") {
            filter = null;
        }
        else {
            filter = {
                ColumnName: "model",
                Type: "contains",
                Value: event.target.value
            }
        }
        setState((currentState) => ({
            ...currentState,
            deviceModelFilter: filter
        }));
    }

    /**
   * Search device by device certificate issue date
   */
    const searchByIssueDate = () => {
        issueDatePopupRef.current.close();
        setState((currentState) => ({
            ...currentState,
            issueDateFilter: {
                ColumnName: "certgenerationdate",
                Type: "between",
                FromValue: moment(currentState.issueFromDate).format('DD/MM/YYYY'),
                ToValue: moment(currentState.issueToDate).format('DD/MM/YYYY')
            },
            searchIssueDate: moment(currentState.issueFromDate).format('DD/MM/YY') + " To " + moment(currentState.issueToDate).format('DD/MM/YY')
        }));
    }

    /**
   * Search device by device certificate expiry date
   */
    const searchByExpDate = () => {
        expDatePopupRef.current.close()
        setState((currentState) => ({
            ...currentState,
            expDateFilter: {
                ColumnName: "certexpirydate",
                Type: "between",
                FromValue: moment(currentState.expFromDate).format('DD/MM/YYYY'),
                ToValue: moment(currentState.expToDate).format('DD/MM/YYYY')
            },
            searchExpDate: moment(currentState.expFromDate).format('DD/MM/YY') + " To " + moment(currentState.expToDate).format('DD/MM/YY')
        }));
    }

    /**
   * Search device by device status
   * @param    {Event} event  User action (on changing value)
   */
    const searchByIsActive = (event) => {
        setState((currentState) => ({
            ...currentState,
            searchIsActive: event.target.value
        }));

        var filter;
        if (event.target.value == "") {
            filter = null;
        }
        else {
            filter = {
                ColumnName: "status",
                Type: "contains",
                Value: event.target.value
            }
        }
        setState((currentState) => ({
            ...currentState,
            isActiveFilter: filter
        }));
    }

    /**
   * Clear all the applied filters
   */
    const clearFilters = () => {
        setState((currentState) => ({
            ...currentState,
            deviceNameFilter: null,
            deviceSerialNumberFilter: null,
            deviceModelFilter: null,
            issueDateFilter: null,
            expDateFilter: null,
            isActiveFilter: null,
            searchDeviceName: "",
            searchSerialNumber: "",
            searchDeviceModel: "",
            searchIssueDate: "",
            searchExpDate: "",
            searchIsActive: "",
            issueFromDate: 'DD/MM/YYYY',
            issueToDate: 'DD/MM/YYYY',
            expFromDate: 'DD/MM/YYYY',
            expToDate: 'DD/MM/YYYY'
        }))
    }

    /**
   * Reset the page to default
   */
    const resetPage = async () => {
        setState((currentState) => ({
            ...currentState,
            status: "LOADED",
            error: null,
            serialNum: "",
            deviceId: "",
            perPage: 20,
            currentPage: 0,
            sortField: null,
            sortType: null,
            selectedItems: [],
            showFilter: false,
            allColumnFilter: null,
            deviceNameFilter: null,
            deviceSerialNumberFilter: null,
            deviceModelFilter: null,
            issueDateFilter: null,
            expDateFilter: null,
            isActiveFilter: null,
            searchDeviceName: "",
            searchSerialNumber: "",
            searchDeviceModel: "",
            searchIssueDate: "",
            searchExpDate: "",
            searchIsActive: "",
            isTableLoading: false,
            issueFromDate: 'DD/MM/YYYY',
            issueToDate: 'DD/MM/YYYY',
            expFromDate: 'DD/MM/YYYY',
            expToDate: 'DD/MM/YYYY',
            model: null,
            success: null,
            message: null,
            hiddenColumns: [],
            allDevices: [],
            selectedItemsForPopup: []
        }));
        searchValue.current.value = ""
        table.getHeaderGroups().map((headerGroup) => (
            headerGroup.headers.map((header) => (
                header.column.resetSize()
            ))
        ))
    }

    /**
   * Show the selected column in devices table
   * @param    {String} columnName  Column name that user selected to show
   */
    const showColumn = (columnName) => {
        if (columnName == "") {
            setState((currentState) => ({
                ...currentState,
                hiddenColumns: []
            }));
        }

        var columns = state.hiddenColumns.filter(c => c != columnName);

        setState((currentState) => ({
            ...currentState,
            hiddenColumns: columns
        }));
    }

    /**
   * Hide the selected column from devices table
   * @param    {String} columnName  Column name that user selected to hide
   */
    const hideColumn = (columnName) => {
        var columns = state.hiddenColumns;
        columns.push(columnName);

        setState((currentState) => ({
            ...currentState,
            hiddenColumns: columns
        }));
    }

    /**
   * Show all the columns in devices table
   */
    const showAllColumns = () => {
        setState((currentState) => ({
            ...currentState,
            hiddenColumns: []
        }));
    }

    /**
   * Activate or deactivate the device
   * @param    {Boolean} isActive  true to activate and false to deactivate
   */
    const ActivateDeactivateDevice = async (isActive) => {
        try {
            await DeviceService.ActivateDeactivateDevice(
                state.serialNum,
                isActive
            );

            setState((currentState) => ({
                ...currentState,
                /*selectedItems: [],*/
                model: null,
                success: true,
                message: "Device " + (isActive == true ? "activated" : "deactivated")
            }));
        } catch (error) {
            setState((currentState) => ({
                ...currentState,
                status: "ERROR",
                error: error
            }));
        }
    };

    /**
   * Triggers manual certificate rotation for the device selected via modelOpenHandler("forceRotate", serialNum)
   */
    const ForceRotateCertificate = async () => {
        try {
            const response = await DeviceService.ForceCertificateRotation(state.serialNum);

            if (response.response == null) {
                setState((currentState) => ({
                    ...currentState,
                    model: null,
                    status: "ERROR",
                    error: new Error(response.errors?.[0]?.message || "Failed to trigger certificate rotation.")
                }));
            } else {
                setState((currentState) => ({
                    ...currentState,
                    model: null,
                    success: true,
                    message: response.response
                }));
            }
        } catch (error) {
            setState((currentState) => ({
                ...currentState,
                status: "ERROR",
                error: error
            }));
        }
    };

    /**
   * Deletes all the selected devices
   */
    const DeleteDevice = async () => {
        try {
            var Ids = [];
            state.selectedItems.forEach(d => Ids.push(d.DeviceId));
            var request = {
                Ids: Ids
            }
            await DeviceService.BulkDeleteDeviceDetails(request);

            setState((currentState) => ({
                ...currentState,
                selectedItems: [],
                model: null,
                success: true,
                message: "Devices deleted"
            }));
        } catch (error) {
            setState((currentState) => ({
                ...currentState,
                status: "ERROR",
                error: error,
            }));
        }
    };

    /**
   * Edit selected devices
   * @param    {Boolean} isActive  true to activate and false to deactivate
   * @param    {String} deviceModelId  Unique identifier of device model
   */
    const bulkEditDevices = async (isActive, deviceModelId) => {
        var devices = [];
        state.selectedItems.forEach(device => {
            var request = {
                SerialNum: device.DeviceSerialNum,
                IsActive: isActive,
                DeviceModelId: deviceModelId
            }
            devices.push(request);
        });

        var request = {
            Devices: devices
        }

        try {
            await DeviceService.BulkEditDeviceDetails(request);

            setState((currentState) => ({
                ...currentState,
                selectedItems: [],
                selectedItemsForPopup: currentState.selectedItems,
                model: null,
                success: true,
                message: "Devices Updated"
            }));
        } catch (error) {
            setState((currentState) => ({
                ...currentState,
                status: "ERROR",
                error: error,
            }));
        }
    }

    /**
   * Opens model
   * @param    {String} model  Name of model to open
   * @param    {String} param  Value of parameter corresponding to model
   */
    const modelOpenHandler = (model, param) => {
        if (model == "activate" || model == "deactivate" || model == "forceRotate") {
            setState((currentState) => ({
                ...currentState,
                serialNum: param
            }));
        }
        else if (model == "edit") {
            setState((currentState) => ({
                ...currentState,
                deviceId: param
            }));
        }

        setState((currentState) => ({
            ...currentState,
            model: model
        }));
    }

    /**
   * Closes opened model
   */
    const modelCloseHandler = async () => {
        setState((currentState) => ({
            ...currentState,
            model: null
        }));
    }

    /**
   * Display message
   * @param    {String} message  Message needs to be displayed
   */
    const messageDisplayHandler = async (message) => {
        setState((currentState) => ({
            ...currentState,
            selectedItems: [],
            selectedItemsForPopup: [],
            success: true,
            message: message
        }));
    }

    /**
   * Closes message popup
   */
    const messagePopupCloseHandler = () => {
        setState((currentState) => ({
            ...currentState,
            selectedItems: [],
            selectedItemsForPopup: [],
            success: null,
            message: null
        }));
    }

    //#endregion

    return (
        <>
            {state.status == "LOADING" && <LoadingIndicator size="large" message="Fetching..." />}
            {state.status == "ERROR" && (state.error?.message?.indexOf("404") > -1 ? <NoMatch /> : <Alert variant="danger">{state.error?.message}</Alert>)}
            {state.status == "LOADED" &&
                <>
                    <Navigation />
                    <TopNavigation onPageReset={loadDeviceDetails} />
                    <div className="page-container">
                        {state.success && <MessagePopup onClose={messagePopupCloseHandler} title="Success" body={<div className="message-popup-container-body"> {state.message}
                            {state.selectedItemsForPopup.length != 0 &&
                                <table className="popup-table">
                                    <tr>
                                        <th className="warning-message-popup-first">DeviceName</th>
                                        <th className="warning-message-popup-last">SerialNumber</th>
                                    </tr>
                                    <tbody className="popup-tbody"> {state.selectedItemsForPopup?.slice(0, 3).map(deviceDetails => (
                                        <tr>
                                            <td className="warning-message-popup-first">
                                                {deviceDetails.DeviceName}
                                            </td>
                                            <td className="warning-message-popup-last">
                                                {deviceDetails.DeviceSerialNum}
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                    <div className="bottom-title">
                                        {state.selectedItemsForPopup?.length > 3 && <p>... and {state.selectedItemsForPopup.length - 3} more {state.selectedItemsForPopup.length - 3 == 1 ? 'record' : 'records'}. </p>}
                                    </div>
                                </table>}
                        </div>} />}
                        {state.model == "add" && <AddDevice onShowMessage={messageDisplayHandler} onClose={modelCloseHandler} action="Yes" />}
                        {state.model == "edit" && <EditDevice onShowMessage={messageDisplayHandler} onClose={modelCloseHandler} action="Yes" deviceId={state.deviceId} />}
                        {state.model == "upload" && <UploadDevice onShowMessage={messageDisplayHandler} onClose={modelCloseHandler} action="Yes" />}
                        {state.model == "delete" && <WarningMessagePopup onClose={modelCloseHandler} title="Delete Device" body={<div className="message-popup-container-body"> Do you want to Delete :
                            {state.selectedItems != null &&
                                <table className="popup-table">
                                    <tr>
                                        <th className="warning-message-popup-first">DeviceName</th>
                                        <th className="warning-message-popup-last">SerialNumber</th>
                                    </tr>

                                    <tbody className="popup-tbody"> {state.selectedItems?.slice(0, 3).map(deviceDetail => (
                                        <tr>
                                            <td className="warning-message-popup-first">
                                                {deviceDetail.DeviceName}
                                            </td>
                                            <td className="warning-message-popup-last">
                                                {deviceDetail.DeviceSerialNum}
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                    <div className="bottom-title">
                                        {state.selectedItems?.length > 3 && <p>... and {state.selectedItems.length - 3} more {state.selectedItems.length - 3 == 1 ? 'record' : 'records'} ? </p>}
                                    </div>
                                </table>}
                        </div>} action="Yes" onAction={DeleteDevice} />}
                        {state.model == "bulkedit" && <BulkEditDevices onClose={modelCloseHandler} onSaveClick={bulkEditDevices} />}
                        {state.model == "deactivate" && <WarningMessagePopup onClose={modelCloseHandler} title="Deactivate Device" body="Do you want to Deactivate?" action="Yes" onAction={() => ActivateDeactivateDevice(false)} />}
                        {state.model == "activate" && <WarningMessagePopup onClose={modelCloseHandler} title="Activate Device" body="Do you want to Activate?" action="Yes" onAction={() => ActivateDeactivateDevice(true)} />}
                        {state.model == "forceRotate" && <WarningMessagePopup onClose={modelCloseHandler} title="Force Rotate Certificate" body="Do you want to force rotate the certificate for this device?" action="Yes" onAction={ForceRotateCertificate} />}
                        <PageTop searchPlaceholder="Search Devices"
                            addButtonText="Add Device"
                            disableSecondAddButton
                            uploadButtonText="Upload Devices"
                            searchRef={searchValue}
                            showFilter={state.showFilter}
                            searchAllColumnHandler={searchAllColumn}
                            resetPageHandler={resetPage}
                            filterColumnHandler={() => {
                                setState((currentState) => ({ ...currentState, showFilter: !currentState.showFilter }));
                                if (state.showFilter) {
                                    clearFilters();
                                }
                            }}
                            modelOpenHandler={modelOpenHandler}
                            menuData={<div className="menu-popup-container">
                                <span className="bold-underline-text" onClick={() => {
                                    showAllColumns();
                                }}>
                                    ShowAll
                                </span>
                                <div className="columns-container">
                                    {table.getHeaderGroups().map(headerGroup => (
                                        headerGroup.headers.map(header => (
                                            <div className="column-container">
                                                <span className="column-text">{header.column.columnDef.accessorKey}</span>
                                                <span className="column-icon">
                                                    {state.hiddenColumns?.includes(header.id) ?
                                                        <Hide onClick={() => {
                                                            showColumn(header.id);
                                                        }} />
                                                        : <Show style={{ opacity: 0.5 }} onClick={() => {
                                                            hideColumn(header.id);
                                                        }} />}
                                                </span>
                                            </div>
                                        ))
                                    ))}
                                </div>
                                <div style={{ margin: "0 8px 10px 8px", borderTop: "1px solid #ddd" }}></div>
                                <div className="columns-container">
                                    <div className="bottom-column-container">
                                        {state.deviceDetails.length === 0 ?
                                            (<span className="bottom-column-text" style={{ opacity: 0.5 }}>
                                                Export All...
                                            </span>) :
                                            (<>
                                                <span className="bottom-column-text" onClick={getAllDevices} style={{ cursor: "pointer", maxWidth: "fit-content" }}>Export All...</span>
                                                <CSVLink
                                                    data={state.allDevices}
                                                    headers={csvHeader}
                                                    separator={","}
                                                    filename={"Device.csv"}
                                                    asyncOnClick={true}
                                                    ref={csvRef} target="_blank" ></CSVLink>
                                            </>
                                            )}
                                    </div>
                                    <div className="bottom-column-container">
                                        {state.selectedItems.length === 0 ?
                                            (<span className="bottom-column-text" style={{ opacity: 0.5 }}>
                                                Export Selected...
                                            </span>) :
                                            (<span>
                                                <CSVLink className="bottom-column-text"
                                                    data={state.selectedItems}
                                                    headers={csvHeader}
                                                    separator={","}
                                                    filename={"Device.csv"}>
                                                    Export Selected...
                                                </CSVLink>
                                            </span>)}
                                    </div>
                                </div>
                            </div>} />
                        <PageTable isTableLoading={state.isTableLoading}
                            tableData={
                                <table>{/*style={{ width: table.getTotalSize() }}*/}
                                    <thead className="table-header">
                                        <tr class="normal-header">
                                            <th scope="col" style={{ padding: "0 5px 0 5px" }}>
                                                {state.selectedItems.length == 0 ?
                                                    <Col className="menu-icon-container">
                                                        <CheckBoxUnselected onClick={selectAllItems} />
                                                        <CheckBoxUnselectedHover className="hover-icon" onClick={selectAllItems} />
                                                    </Col>
                                                    :
                                                    (state.selectedItems.length == state.deviceDetails.length ?
                                                        <Col className="menu-icon-container">
                                                            <CheckBoxSelected onClick={unSelectAllItems} />
                                                            <CheckBoxSelectedHover className="hover-icon" onClick={unSelectAllItems} />
                                                        </Col> :
                                                        <Col className="menu-icon-container">
                                                            <CheckBoxPartial onClick={selectAllItems} />
                                                            <CheckBoxPartialHover className="hover-icon" onClick={selectAllItems} />
                                                        </Col>)}
                                            </th>
                                            {table.getHeaderGroups().map(headerGroup => (
                                                headerGroup.headers.map(header => (
                                                    !state.hiddenColumns.includes(header.id) &&
                                                    <th key={header.id} scope="col"
                                                        style={{ width: header.getSize(), cursor: "pointer", textAlign: header.column.columnDef.meta.type == "date" ? "right" : (header.column.columnDef.meta.type == "bool" ? "center" : "left") }}>
                                                        <div className="header-text-wrapper" onClick={() => { sort(header.column.columnDef.meta.sortFieldName) }}>
                                                            {state.sortField == header.column.columnDef.meta.sortFieldName && state.sortType == "asc" ?
                                                                <div className={`${header.column.columnDef.meta.type == "date" ? 'sort-icon-left' : 'sort-icon-right'}`}>
                                                                    <DescendingIcon />
                                                                    <AscendingHoverIcon />
                                                                </div> : (state.sortField == header.column.columnDef.meta.sortFieldName && state.sortType == "desc" ?
                                                                    <div className={`${header.column.columnDef.meta.type == "date" ? 'sort-icon-left' : 'sort-icon-right'}`} >
                                                                        <DescendingHoverIcon />
                                                                        <AscendingIcon />
                                                                    </div> : <div className={`${header.column.columnDef.meta.type == "date" ? 'sort-icon-left' : 'sort-icon-right'}`} >
                                                                        <DescendingIcon />
                                                                        <AscendingIcon />
                                                                    </div>)}
                                                            {header.isPlaceholder
                                                                ? null
                                                                : flexRender(
                                                                    header.column.columnDef.header,
                                                                    header.getContext()
                                                                )}
                                                        </div>
                                                        <div className={`resize-handle ${header.column.getIsResizing() ? 'active' : null}`} onMouseDown={header.getResizeHandler()} onTouchStart={header.getResizeHandler()}></div>
                                                    </th>
                                                ))
                                            ))}
                                            <th scope="col" style={{ width: "60px", textAlign: "center" }}>Edit</th>
                                            <th scope="col" style={{ width: "60px", textAlign: "center" }}>Rotate</th>
                                        </tr>
                                        {state.showFilter &&
                                            <tr class="filter-header">
                                                <th scope="col"></th>
                                                {!state.hiddenColumns.includes("DeviceName") &&
                                                    <th scope="col" style={{ padding: "0 5px 0 5px" }} >
                                                        <TextFilterBox clearFilterHandler={() => {
                                                            setState((currentState) => ({
                                                                ...currentState,
                                                                searchDeviceName: "", deviceNameFilter: null,
                                                            }));
                                                        }}
                                                            searchPlaceHolder={state.searchDeviceName}
                                                            searchHandler={searchByDeviceName} />
                                                    </th>}
                                                {!state.hiddenColumns.includes("SerialNum") &&
                                                    <th scope="col" style={{ padding: "0 5px 0 5px" }} >
                                                        <TextFilterBox clearFilterHandler={() => {
                                                            setState((currentState) => ({
                                                                ...currentState,
                                                                searchSerialNumber: "", deviceSerialNumberFilter: null,
                                                            }));
                                                        }}
                                                            searchPlaceHolder={state.searchSerialNumber}
                                                            searchHandler={searchBySerialNumber} />
                                                    </th>}
                                                {!state.hiddenColumns.includes("DeviceModel") &&
                                                    <th scope="col" style={{ padding: "0 5px 0 5px" }} >
                                                        <TextFilterBox clearFilterHandler={() => {
                                                            setState((currentState) => ({
                                                                ...currentState,
                                                                searchDeviceModel: "", deviceModelFilter: null,
                                                            }));
                                                        }}
                                                            searchPlaceHolder={state.searchDeviceModel}
                                                            searchHandler={searchByDeviceModel} />
                                                    </th>}
                                                {!state.hiddenColumns.includes("IssueDate") &&
                                                    <th scope="col" style={{ padding: "0 5px 0 5px" }} >
                                                        <ReactCalendarPopup searchDatePlaceHolder={state.searchIssueDate}
                                                            popupRef={issueDatePopupRef}
                                                            fromDateVar={state.issueFromDate}
                                                            toDateVar={state.issueToDate}
                                                            searchHandler={searchByIssueDate}
                                                            setFromDateHandler={(date) => setState((currentState) => ({ ...currentState, issueFromDate: date }))}
                                                            setToDateHandler={(date) => setState((currentState) => ({ ...currentState, issueToDate: date }))}
                                                            resetHandler={() => { setState((currentState) => ({ ...currentState, issueFromDate: 'DD/MM/YYYY', issueToDate: 'DD/MM/YYYY' })) }}
                                                            filterClearHandler={() => {
                                                                setState((currentState) => ({
                                                                    ...currentState,
                                                                    searchIssueDate: "",
                                                                    issueDateFilter: null,
                                                                    issueFromDate: 'DD/MM/YYYY',
                                                                    issueToDate: 'DD/MM/YYYY',
                                                                }))
                                                            }} />
                                                    </th>}
                                                {!state.hiddenColumns.includes("ExpiredDate") &&
                                                    <th scope="col" style={{ padding: "0 5px 0 5px" }}>
                                                        <ReactCalendarPopup searchDatePlaceHolder={state.searchExpDate}
                                                            popupRef={expDatePopupRef}
                                                            fromDateVar={state.expFromDate}
                                                            toDateVar={state.expToDate}
                                                            searchHandler={searchByExpDate}
                                                            setFromDateHandler={(date) => setState((currentState) => ({ ...currentState, expFromDate: date }))}
                                                            setToDateHandler={(date) => setState((currentState) => ({ ...currentState, expToDate: date }))}
                                                            resetHandler={() => { setState((currentState) => ({ ...currentState, expFromDate: 'DD/MM/YYYY', expToDate: 'DD/MM/YYYY' })) }}
                                                            filterClearHandler={() => {
                                                                setState((currentState) => ({
                                                                    ...currentState,
                                                                    searchExpDate: "",
                                                                    expDateFilter: null,
                                                                    expFromDate: 'DD/MM/YYYY',
                                                                    expToDate: 'DD/MM/YYYY',
                                                                }))
                                                            }} />
                                                    </th>}
                                                {!state.hiddenColumns.includes("IsActive") &&
                                                    <th scope="col" style={{ textAlign: "center", padding: "0 5px 0 5px" }}>
                                                        <label className="filter-label">
                                                            <select className="filter-input" value={state.searchIsActive} onChange={searchByIsActive}>
                                                                <option value="null" selected >-All-</option>
                                                                <option value="true">Active</option>
                                                                <option value="false">InActive</option>
                                                            </select>
                                                            {state.searchIsActive != "" &&
                                                                <div className="filter-clear-icon-container" >
                                                                    <Filterclearbuttonhover className="filter-clear-icon hover-icon" onClick={() => {
                                                                        setState((currentState) => ({
                                                                            ...currentState,
                                                                            isActiveFilter: null,
                                                                            searchIsActive: ""
                                                                        }))
                                                                    }} />
                                                                    <Filterclearbutton className="filter-clear-icon" />
                                                                </div>
                                                            }
                                                        </label>
                                                    </th>}
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                            </tr >
                                        }
                                    </thead>
                                    {!state.isTableLoading &&
                                        <tbody>
                                            {table.getRowModel().rows.map(row => (
                                                <tr key={row.id} className={state.selectedItems.find(sel => sel.DeviceName == state.deviceDetails[row.id].DeviceName && sel.DeviceSerialNum == state.deviceDetails[row.id].DeviceSerialNum) == null ? '' : 'selected'}>
                                                    <td scope="col">
                                                        {state.selectedItems.find(sel => sel.DeviceName == state.deviceDetails[row.id].DeviceName && sel.DeviceSerialNum == state.deviceDetails[row.id].DeviceSerialNum) == null ?
                                                            <Col className="menu-icon-container">
                                                                <CheckBoxUnselected onClick={() => { selectItem(state.deviceDetails[row.id]) }} />
                                                                <CheckBoxUnselectedHover className="hover-icon" onClick={() => { selectItem(state.deviceDetails[row.id]) }} />
                                                            </Col>
                                                            :
                                                            <Col className="menu-icon-container">
                                                                <CheckBoxSelected onClick={() => { unSelectItem(state.deviceDetails[row.id]) }} />
                                                                <CheckBoxSelectedHover className="hover-icon" onClick={() => { unSelectItem(state.deviceDetails[row.id]) }} />
                                                            </Col>
                                                        }
                                                    </td>
                                                    {row.getVisibleCells().map(cell => (
                                                        !state.hiddenColumns.includes(cell.column.id) &&
                                                        (cell.column.columnDef.meta.type == "date" ?
                                                            <td scope="col" key={cell.id} style={{ textAlign: "right" }}>
                                                                <div className="body-text-wrapper">
                                                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                                </div>
                                                            </td> :
                                                            (cell.column.columnDef.meta.type == "bool" ? (state.deviceDetails[row.id].Status === "Active" ? (
                                                                <td scope="col" style={{ textAlign: "center" }}>
                                                                    <span className="menu-icon-container" style={{ marginLeft: 0 }}>
                                                                        <CheckBoxSelected onClick={() => modelOpenHandler("deactivate", state.deviceDetails[row.id].DeviceSerialNum)} />
                                                                        <CheckBoxSelectedHover className="hover-icon" onClick={() => modelOpenHandler("deactivate", state.deviceDetails[row.id].DeviceSerialNum)} />
                                                                    </span>
                                                                </td>
                                                            ) : (
                                                                <td scope="col" style={{ textAlign: "center" }}>
                                                                    <span className="menu-icon-container" style={{ marginLeft: 0 }}>
                                                                        <CheckBoxUnselected onClick={() => modelOpenHandler("activate", state.deviceDetails[row.id].DeviceSerialNum)} />
                                                                        <CheckBoxUnselectedHover className="hover-icon" onClick={() => modelOpenHandler("activate", state.deviceDetails[row.id].DeviceSerialNum)} />
                                                                    </span>
                                                                </td>
                                                            )) :
                                                                <td scope="col" key={cell.id}>
                                                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                                </td>)
                                                        )
                                                    ))}
                                                    <td scope="col" style={{ width: "60px", textAlign: "center" }}>
                                                        <span className="menu-icon-container">
                                                            <Edit className="menu-icon" onClick={() => modelOpenHandler("edit", state.deviceDetails[row.id].DeviceId)} />
                                                            <EditPenHover className="menu-icon hover-icon" onClick={() => modelOpenHandler("edit", state.deviceDetails[row.id].DeviceId)} />
                                                        </span>
                                                    </td>
                                                    <td scope="col" style={{ width: "60px", textAlign: "center" }}>
                                                        <span className="menu-icon-container">
                                                            {state.deviceDetails[row.id].CertGenerationDate != null ?
                                                                <ForceRotate className="menu-icon" title="Force Rotate Certificate" onClick={() => modelOpenHandler("forceRotate", state.deviceDetails[row.id].DeviceSerialNum)} />
                                                                :
                                                                <ForceRotate className="menu-icon" style={{ opacity: 0.3, cursor: "not-allowed" }} title="No certificate present for this device" />}
                                                        </span>
                                                    </td>
                                                </tr>

                                            ))}
                                        </tbody>}
                                </table>
                            } />
                        <Footer onFirstClick={firstPageHandler}
                            onLastClick={lastPageHandler}
                            onPreviousClick={previousPageHandler}
                            onNextClick={nextPageHandler}
                            perPage={state.perPage}
                            totalData={state.totalDataCount}
                            showingItemsCount={state.deviceDetails.length}
                            currentPage={state.currentPage + 1}
                            totalPage={state.pageCount}
                            selectedItems={state.selectedItems.length}
                            changePerPage={changePerPage}
                            modelOpenHandler={modelOpenHandler} />
                    </div >
                </>
            }
        </>
    )
}

export default Device;